import { useFailClosedFlag } from './useFailClosedFlag';
import { flagsmithFeatureFlags } from '@/lib/flagsmith';

/**
 * Resolves the `mcp_inventory_enforcement` flag for the Inventory MCP Servers
 * tab (KIR-4482). Fails closed on loading/error so the New signal and the
 * Enforcement column never flash in before the flag is known; `isLoading`
 * lets the tab hold a deep link's filtered query until the flag is in.
 */
export function useMcpInventoryEnforcementEnabled(): {
  enabled: boolean;
  isLoading: boolean;
} {
  return useFailClosedFlag(flagsmithFeatureFlags.MCP_INVENTORY_ENFORCEMENT);
}
